<template>
  <b-overlay
      variant="white"
      :show="getShowLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="md"
  >
  <div>
    <b-card
        no-body
        class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end actions-wrapper">
              <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por código interno, código, referência ou marca..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              <b-button
                  variant="outline-primary"
                  class="d-flex"
                  @click="isBulkUploadModal = true"
              >
                <feather-icon
                    icon="UploadIcon"
                    class="mr-50"
                />
                <span class="align-middle">Upload em massa</span>
              </b-button>
              <b-button
                  variant="primary"
                  :to="{ name: 'template-imagem-novo' }"
                  class="d-flex"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Template Imagem</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refDataTableTemplateImagem"
          class="position-relative"
          :items="fetchTemplateImagem"
          responsive
          :fields="tableColumns"
          primary-key="log_img_id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Nenhum registro encontrado"
          :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(caminho)="data">
          <b-img class="mb-1 mb-sm-0" height="100%" width="120" :src="data.value"
                 :alt="`Imagem id ${data.item.log_img_id}`"/>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                title="Visualizar"
                variant="gradient-primary"
                :to="{ name: 'template-imagem-edit-cdn_marca-familia_comercial_id', params: { cdnMarca: data.item.cod_marca, familiaComercialId: data.item.familia_comercial_id } }"
                class="btn-icon mr-1"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                title="Deletar"
                variant="gradient-danger"
                @click="showModalDeleteTemplateImagem(data.item.familia_comercial_id)"
                class="btn-icon"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
                dataMeta.of
              }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalTemplateImagem"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-imagem-home"
        title="Deletar Imagem"
        message="Tem certeza que deseja deletar?"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="deleteTemplateImagem"
        @cancel="isDeleteModal = false"
    />

    <modal-bulk-upload
        v-model="isBulkUploadModal"
        @uploaded="refetchData"
    />
  </div>
  </b-overlay>
</template>

<script>
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import TemplateImagemService from '@/services/SistemaDKP/sls-template-imagem.service';
import store from '@/store';
import { BOverlay } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import ModalBulkUpload from './ModalBulkUpload.vue';
import useList from './useList';

export default {
  components: {
    BOverlay,
    ModalConfirmation,
    ModalBulkUpload,
  },
  data() {
    return {
      searchInputValue: '',
      isBulkUploadModal: false,
    };
  },
  computed: {
    ...mapGetters('slsTemplateImagem', {
      getShowLoading: 'getShowLoading',
    }),
  },
  methods: {
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const isDeleteModal = ref(false);
    const temaplateImagem = new TemplateImagemService();
    const idTemplateImagemDelete = ref(null);
    const {
      fetchTemplateImagem,
      tableColumns,
      perPage,
      currentPage,
      totalTemplateImagem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableTemplateImagem,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
    } = useList();

    const showModalDeleteTemplateImagem = (id) => {
      idTemplateImagemDelete.value = id;
      isDeleteModal.value = true;
    };
    const deleteTemplateImagem = async () => {
      await temaplateImagem.delete(idTemplateImagemDelete.value);
      isDeleteModal.value = false;
      refetchData();
    };

    return {
      fetchTemplateImagem,
      // Sidebar
      isDeleteModal,
      tableColumns,
      perPage,
      currentPage,
      totalTemplateImagem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableTemplateImagem,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      deleteTemplateImagem,
      showModalDeleteTemplateImagem,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
